import { render, staticRenderFns } from "./ScoreStep.vue?vue&type=template&id=7df4db7c&"
import script from "./ScoreStep.vue?vue&type=script&lang=js&"
export * from "./ScoreStep.vue?vue&type=script&lang=js&"
import style0 from "./ScoreStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df4db7c')) {
      api.createRecord('7df4db7c', component.options)
    } else {
      api.reload('7df4db7c', component.options)
    }
    module.hot.accept("./ScoreStep.vue?vue&type=template&id=7df4db7c&", function () {
      api.rerender('7df4db7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/雙人合盤/ScoreStep.vue"
export default component.exports